import { useState } from 'react';

export default function Brands() {
    const [expandedBrands, setExpandedBrands] = useState<Record<number, boolean>>({});

    const toggleBrandLinks = (index: number) => {
        setExpandedBrands(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const brands = [
        {
            name: 'Jonnesway',
            logo: 'https://www.pride.ru/images/logos/jonnesway.svg',
            links: [
                {
                    name: 'Подробнее о бренде',
                    link: 'https://jonnesway.ru/page/about/'
                },
                {
                    name: 'Скачать каталог в формате PDF',
                    link: 'https://www.pride.ru/files/jw_2025.pdf'
                }
            ]
        },
        {
            name: 'Ombra',
            logo: 'https://www.pride.ru/images/logos/ombra.svg',
            links: [
                {
                    name: 'Подробнее о бренде',
                    link: 'https://ombratools.ru/about/'
                },
                {
                    name: 'Скачать каталог в формате PDF',
                    link: 'https://www.pride.ru/files/ombra_2025.pdf'
                }
            ]
        },
        {
            name: 'Thorvik',
            logo: 'https://www.pride.ru/images/logos/thorvik.svg',
            links: [
                {
                    name: 'Подробнее о бренде',
                    link: 'https://thorvik.ru/about'
                },

                {
                    name: 'Скачать каталог в формате PDF',
                    link: 'https://thorvik.ru/files/thorvik_2026.pdf'
                }
            ]

        },
        {
            name: 'Carbon',
            logo: 'https://www.pride.ru/images/logos/carbon2.svg',
            links: [
                {
                    name: 'Подробнее о бренде',
                    link: 'https://carbontools.ru/about'
                },
                {
                    "name": "Скачать каталог: Фрезерная обработка материалов. Монолитные фрезы (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_monolitnie_frezi_web.pdf"
                },
                {
                    "name": "Скачать каталог: Обработка отверстий (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_obrabotka_otverstiy_web.pdf"
                },
                {
                    "name": "Скачать каталог: Токарная обработка (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_tokarnaya_obrabotka_web.pdf"
                },
                {
                    "name": "Скачать каталог: Пневматический инструмент (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_pnevmatika_web.pdf"
                },
                {
                    "name": "Скачать каталог: Тиски (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_tiski_web.pdf"
                },
                {
                    "name": "Скачать каталог: Цанги ER (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_cangi_web.pdf"
                },
                {
                    "name": "Скачать каталог: Токарная обработка. Точение резьбы (в формате PDF)",
                    "link": "https://www.pride.ru/files/carbon_rezba_web.pdf"
                }
            ]

        },
        {
            name: 'FILL Inn',
            logo: 'https://www.pride.ru/images/logos/fillinn.svg',
            links: [
                {
                    name: 'Подробнее о бренде',
                    link: 'https://fill-inn.com/page/about/'
                },

                {
                    "name": "Скачать каталог основного ассортимента (PDF)",
                    "link": "https://www.fill-inn.com/public/files/fillinn/fillin_2023_web.pdf"
                },
                {
                    "name": "Скачать каталог профессиональной автохимии (PDF)",
                    "link": "https://www.fill-inn.com/public/files/fillinn/fillInn_pro_2024_web.pdf"
                }
            ]

        },
        {
            name: 'Pride',
            logo: 'https://www.pride.ru/cloudmill/images/logo.svg',
            links: [
                {
                    name: 'Подробнее о бренде',
                    link: 'https://www.pride.ru/about'
                },

                {
                    name: 'Скачать каталог Pride Industrial (PDF)',
                    link: 'https://www.pride.ru/files/pride_industrial.pdf'
                }
            ]

        },
        // {
        //     name: 'Rotake',
        //     logo: 'https://www.pride.ru/images/logos/rotake.svg',
        //     link: 'https://rotakepro.ru/#brand'
        // }
    ];

    return (
        <div className="provider">
            <div className="container">
                <h2 className="t-two provider__title">
                    Один из крупнейших в России поставщиков профессионального слесарно-монтажного инструмента
                </h2>
                <div className="row g-3 g-sm-4 gx-lg-6 gy-lg-6 provider__row">
                    {brands.map((brand, index) => {
                        const isExpanded = expandedBrands[index];
                        const hasMultipleLinks = brand.links.length > 2;
                        const displayLinks = hasMultipleLinks && !isExpanded
                            ? [brand.links[0]]
                            : brand.links;

                        return (
                            <div key={index} className="col-xxl-3 col-12 col-lg-4 col-sm-6 provider__item">
                                <div className="d-flex flex-column align-items-center provider__i-body">
                                    <div className="provider__i-logo">
                                        <img className="h-auto w-auto" src={brand.logo} alt={brand.name}/>
                                    </div>
                                    {displayLinks.map((link, linkIndex) => (
                                        <a
                                            key={linkIndex}
                                            href={link.link}
                                            rel="noopener noreferrer"
                                            className="bs-link provider__i-link mt-2"
                                        >
                                            {link.name}
                                        </a>
                                    ))}
                                    {hasMultipleLinks && (
                                        <button
                                            onClick={() => toggleBrandLinks(index)}
                                            className="bs-link provider__i-link mt-2 border-0 bg-transparent p-0 text-muted"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {isExpanded ? 'Свернуть' : 'Посмотреть список каталогов'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/*<button className="d-flex align-items-center btn btn-primary justify-content-end provider__btn">*/}
                {/*    <span>Каталог →</span>*/}
                {/*</button>*/}
            </div>
        </div>
    );
}